export const MODAL_NAME = 'ListingsImportExportDrawer'

export const FORM_TYPES = {
  EXPORT: 'export',
  IMPORT: 'import',
  IMPORT_NEW: 'import-new',
  UPDATE: 'update',
  UPDATES_CONTACTS: 'updates-contacts',
} as const

export const HASH_NAME = 'listing-action'

export const ENCODING_OPTIONS = [
  { value: 'utf-8', label: 'UTF-8' },
  { value: 'latin1', label: 'Latin-1 (CP-1252)' },
]

export type FormTypes = typeof FORM_TYPES
